// 'PURCHASED', 'PAIRING_FAILED', 'PAIRED', 'DEACTIVATING', 'UNPAIRED', 'UNPAIRING_FAILED', 'DEACTIVATED'
export enum SystemNumberStatusEnum {
  PURCHASED = 'PURCHASED',
  PAIRING_FAILED = 'PAIRING_FAILED',
  PAIRED = 'PAIRED',
  DEACTIVATING = 'DEACTIVATING',
  UNPAIRED = 'UNPAIRED',
  UNPAIRING_FAILED = 'UNPAIRING_FAILED',
  DEACTIVATED = 'DEACTIVATED',
}